export default __webpack_public_path__ + "static/media/superiorpro-website.5795fd87.png";